// extracted by mini-css-extract-plugin
module.exports = {"waveLoading":"pd-standalone-video_waveLoading__Xa0gH"};